import React from 'react';
import { Route, Switch } from 'react-router';
import { ErrorBoundary } from './components/errorHandler';
import Layout from './components/layout/Layout';
import APPLogin from './components/login/Login';
import requireAuth from './utils/requireAuth';
import ForgotPassword from './components/login/ForgotPassword';
import ConfirmCode from './components/login/ConfirmCode';
import UserReset from './components/login/UserReset';
import UserResetPassword from './components/login/UserResetPassword';
import Temperature from './components/vehicles/temperature/index';
import MapView from './components/vehicles/mapView/Index';
import ViolationBarChart from './components/Visualization/ViolationBarChart';
import SummaryChart from './components/Visualization/summary';

import GroupAccount from './components/settings/account/index';
import UpdateGroup from './components/settings/updateGroup/index';
import UserList from './components/user/UserList';
import AboutUS from './components/aboutUs/about';
import UserCreate from './components/user/UserCreate';
import UpdateUser from './components/user/UpdateUser';
import GroupsListView from './components/group/list/index';
import GroupCreate from './components/group/create/index';
import GroupUpdate from './components/group/update/index';


import ReportsList from './components/reports/list';
import DistanceReport from './components/reports/distanceReport';
import deviceDetailReport from './components/reports/deviceDetailReport';
import PowerReport from './components/reports/powerReport';
import TemperatureReport from './components/reports/temperatureReport';
import ReportInterval from './components/reports/interval';
import NotificationsList from './components/notifications/list';
import AdminLogin from './components/adminLogin';
import ErrorHandler from './components/common/ErrorHandler';
import ChillerObservation1Page from './components/chiller/index1';
import ChillerObservationPage from './components/chiller';
import HelpComponent from './components/help/index';


import DownloadReports from "./components/reports/DownloadReports";
import observationReport from './components/reports/observationReport';
import troubleShootReport from './components/reports/troubleShootReport';
import { ReportsListing } from './components/reports/reportsList';
import ReportSchedule from './components/reports/scheduleReport';
import deviceSettings from './components/mondelez-settings';
import dataDumpReport from './components/reports/dataDumpReport';
import dayWiseDumpReport from './components/reports/dayWiseDumpReport';


export default () => (
  <Switch>

    <Route path='/login' component={APPLogin} />
    <Route path='/forgot-password' component={ForgotPassword} />
    <Route path='/confirm-code/:userName' component={ConfirmCode} />
    <Route path='/user/activate/:token' component={UserReset} />
    <Route path='/set-password/:id/:token' component={UserResetPassword} />
    <Route path='/user/reset' component={UserReset} />
    <Route path='/adminLogin' component={AdminLogin} />
    <Route path='/error' component={ErrorHandler} />
    <Layout>
      <ErrorBoundary>
        <Route exact path='/' component={requireAuth(MapView)} />
        <Route exact path='/temperature/:id' component={requireAuth(Temperature)} />
       <Route path='/devices/chiller-observation' component={requireAuth(ChillerObservationPage, )} />
       <Route path='/devices/tempchiller-observation' component={requireAuth(ChillerObservation1Page, )} />
       <Route exact path='/account' component={requireAuth(GroupAccount)} />
       <Route exact path = '/mondelezDeviceSettings' component={requireAuth(deviceSettings)} />
        <Route exact path='/account/update/:id' component={requireAuth(UpdateGroup)} />
        <Route exact path='/aboutus' component={requireAuth(AboutUS)} />
        <Route exact path='/users' component={requireAuth(UserList, )} />
        <Route exact path='/users/create/:id'
          component={requireAuth(UserCreate, )} />
        <Route exact path='/user/update/:id' component={requireAuth(UpdateUser)} />
        <Route exact path='/groups' component={requireAuth(GroupsListView, )} />
        <Route exact path='/groups/add' component={requireAuth(GroupCreate)} />
        <Route exact path='/groups/:id/update'
          component={requireAuth(GroupUpdate)} />
       
        
        <Route exact path='/reports' component={requireAuth(ReportsListing, )} />
        <Route exact path='/scheduleReport' component={requireAuth(ReportSchedule, )} />
        
        <Route exact path='/distanceReport' component={requireAuth(DistanceReport, )} />
        <Route exact path='/deviceDetailReport' component={requireAuth(deviceDetailReport, )} />
        <Route exact path='/dataDumpReport' component={requireAuth(dataDumpReport, )} />
         <Route exact path='/dayWiseReport' component={requireAuth(dayWiseDumpReport, )} />
        <Route exact path='/temperatureReport' component={requireAuth(TemperatureReport, )} />
        <Route exact path='/observationReport' component={requireAuth(observationReport, )} />
        <Route exact path='/troubleshootReport' component={requireAuth(troubleShootReport, )} />
        <Route exact path='/eventReport' component={requireAuth(ReportsList, )} />
        <Route exact path='/powerReport' component={requireAuth(PowerReport, )} />
        <Route exact path='/visualization/violations' component={requireAuth(ViolationBarChart, )} />
        <Route exact path='/visualization/summary' component={requireAuth(SummaryChart, )} />
        <Route exact path='/reports/:type' component={requireAuth(ReportInterval, false)} />
        <Route exact path='/notifications' component={requireAuth(NotificationsList)} />
          <Route exact path='/help' component={requireAuth(HelpComponent, false)} />

           <Route exact path='/download/reports' component={requireAuth(DownloadReports,false)} />
       </ErrorBoundary>
    </Layout>

  </Switch>
);


// TODO: Fix vendor after its updated from react-select-nested-group
